module.exports = __webpack_public_path__ + "media/images/old-ticbali-f4a541bbbfeccb92420183e7711c86da.png";